var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.6673H4.66667C3.93029 14.6673 3.33333 14.0704 3.33333 13.334V4.66732H2V3.33398H4.66667V2.66732C4.66667 1.93094 5.26362 1.33398 6 1.33398H10C10.7364 1.33398 11.3333 1.93094 11.3333 2.66732V3.33398H14V4.66732H12.6667V13.334C12.6667 14.0704 12.0697 14.6673 11.3333 14.6673ZM4.66667 4.66732V13.334H11.3333V4.66732H4.66667ZM6 2.66732V3.33398H10V2.66732H6Z",
    fill: "#F17676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.885eb3ecdd5d27540ee6983c9489cb1f.svg";
export { ForwardRef as ReactComponent };